import { render, staticRenderFns } from "./Searchable.vue?vue&type=template&id=57970284&lang=pug"
import script from "./Searchable.vue?vue&type=script&lang=js"
export * from "./Searchable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports